import {Component, Input, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {trigger} from '@angular/animations';
import {smoothEnterLeaveAnimation} from '../../../../shared/animations/custom-animations';
import {ForgotPasswordService} from '../../../services/forgot-password.service';
import * as OtpOptions from '../../../../shared/constants/otp-options.const';
import { PHONE_NUMBER_LIST } from 'src/main/resources/static/angular2/app/shared/constants/phone-numbers.const';
import { DomainNameParserService } from 'src/main/resources/static/angular2/app/shared/services/domain-name-parser.service';

@Component({
  selector: 'app-send-confirmation-code-by-phone',
  templateUrl: './send-confirmation-code-by-phone.component.html',
  styleUrls: [
    './send-confirmation-code-by-phone.component.css',
    '../../../../../assets/css/floating-labels.css'
  ],
  animations: [
    trigger('showSendVerificationSmsButton', smoothEnterLeaveAnimation('100ms 150ms', '100ms')),
    trigger('showConfirmationCodeWindow', smoothEnterLeaveAnimation('100ms 150ms', '100ms'))
  ]
})
export class SendConfirmationCodeByPhoneComponent implements OnInit {

  sendVerificationSmsButtonClicked = false;
  verificationSmsRequestSent = false;
  serverErrorMessageShown = false;
  customerServicePhone;

  resetPasswordByPhoneForm = new FormGroup({
    usernameInput: new FormControl('', [
      Validators.required
    ]),
    phoneNumberInput: new FormControl('', [
      Validators.required
    ])
  });

  constructor(private forgotPasswordService: ForgotPasswordService,
              private domainNameParserService: DomainNameParserService) {
    this.customerServicePhone = PHONE_NUMBER_LIST[this.domainNameParserService.getState()];
  }

  ngOnInit(): void {
  }

  setUsernameInput(username: string): void {
    this.resetPasswordByPhoneForm.controls.usernameInput.setValue(username);
  }

  getUsernameValue(): string {
    return this.resetPasswordByPhoneForm.controls.usernameInput.value;
  }

  setPhoneInput(phone: string): void {
    this.resetPasswordByPhoneForm.controls.phoneNumberInput.setValue(phone);
  }

  getPhoneNumberValue(): string {
    return this.resetPasswordByPhoneForm.controls.phoneNumberInput.value;
  }

  resetPasswordByPhone(): void {
    this.resetErrorsShown();
    this.sendVerificationSmsButtonClicked = true;
    if (!this.resetPasswordByPhoneForm.valid) {
      return;
    }
    this.forgotPasswordService.requestOneTimePassword(this.getUsernameValue(), OtpOptions.SMS_OTP_OPTION,
      this.getPhoneNumberValue()).subscribe(_ => {
        console.log('Resetting password by phone...');
        this.verificationSmsRequestSent = true;
      },
      error => {
        this.showServerErrorMessage();
      });
  }

  private showServerErrorMessage(): void {
    this.serverErrorMessageShown = true;
  }

  private resetErrorsShown(): void {
    this.serverErrorMessageShown = false;
  }
}
